import { Bitcoin, MessagesSquare, Sparkles } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const TRACKS = [
  {
    icon: Bitcoin,
    name: 'Bitcoin & Lightning',
    description:
      'Wallets, payments, ecash, and merchant tools. Make sats move for real people in Kenya.',
    ideas: [
      'A chama savings wallet for women\u2019s groups',
      'Lightning checkout for mama mboga stalls',
      'Split-the-bill app that settles in sats',
    ],
  },
  {
    icon: MessagesSquare,
    name: 'Nostr',
    description:
      'The open social protocol. Build clients, communities, and zap-powered experiences.',
    ideas: [
      'A marketplace for Kenyan artisans on Nostr',
      'Zap-gated content for local creators',
      'A community hub for women builders',
    ],
  },
  {
    icon: Sparkles,
    name: 'Freedom Tech (Open)',
    description:
      'Anything on open protocols that makes life freer, fairer, or more fun. Surprise us.',
    ideas: [
      'USSD bridge for Lightning payments',
      'Offline-first learning with bitcoin rewards',
      'Your wild idea we haven\u2019t thought of',
    ],
  },
];

export function Tracks() {
  return (
    <section id="tracks" className="scroll-mt-20 bg-secondary/50 py-20 sm:py-28">
      <div className="container space-y-12">
        <div className="mx-auto max-w-2xl space-y-4 text-center">
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-primary">
            Hack Tracks
          </p>
          <h2 className="font-display text-4xl font-semibold tracking-tight text-balance sm:text-5xl">
            Pick your playground
          </h2>
          <p className="text-lg leading-relaxed text-muted-foreground">
            Three tracks, one goal: ship something real by Sunday evening.
            Ideas below are just sparks — bring your own.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {TRACKS.map((track) => (
            <Card
              key={track.name}
              className="group flex flex-col border-border/70 transition-all duration-300 hover:-translate-y-1 hover:border-primary/50 hover:shadow-xl hover:shadow-primary/10"
            >
              <CardContent className="flex flex-1 flex-col gap-5 p-6">
                <span className="grid size-12 place-items-center rounded-xl bg-accent text-primary">
                  <track.icon className="size-6" aria-hidden />
                </span>
                <div className="space-y-2">
                  <h3 className="font-display text-2xl font-semibold">{track.name}</h3>
                  <p className="leading-relaxed text-muted-foreground">{track.description}</p>
                </div>
                <ul className="mt-auto space-y-2 border-t border-dashed border-border pt-4 text-sm text-muted-foreground">
                  {track.ideas.map((idea) => (
                    <li key={idea} className="flex items-start gap-2">
                      <span className="mt-2 size-1.5 shrink-0 rounded-full bg-primary" aria-hidden />
                      {idea}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
